
<div>
  <b-row>
    <FileField
      v-model="file"
      :multiple="true"
      class="col-12"
      :label="__('common.file')"
      name="file"
      required
    />

    <TextField
      v-if="!multiple"
      v-model="name"
      name="name"
      :label="__('documents.document-name')"
      class="col-3"
    />

    <SelectField
      v-if="!multiple"
      v-model="type"
      name="type_id"
      :label="__('documents.type')"
      :options="types"
      class="col-3"
    />

    <SelectField
      v-model="documentFolder"
      name="document_folder_id"
      :label="__('documents.folder')"
      :options="documentFolders"
      :class="{'col-3': !multiple, 'col-12': multiple}"
    />

    <TextField
      v-if="!multiple"
      v-model="tag"
      name="tag"
      :label="__('documents.tag')"
      class="col-3"
    />

    <TextAreaField
      v-if="!multiple"
      v-model="description"
      name="description"
      :label="__('common.description')"
      :placeholder="__('documents.description-text')"
      class="col-12"
    />
  </b-row>

  <div class="text-right">
    <b-alert v-if="showEncryptedWarning" show variant="warning" class="text-left mb-2">
      <p class="mb-2">{{ __('documents.encrypted-file-warning') }}</p>
      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="cancelEncryptedUpload">
          {{ __('buttons.cancel') }}
        </b-button>
        <b-button variant="warning" size="sm" @click="confirmEncryptedUpload">
          {{ __('documents.upload-anyway') }}
        </b-button>
      </div>
    </b-alert>

    <b-button v-if="!showEncryptedWarning" variant="primary" size="sm" @click="upload">
      <Icon class="mr-2" icon="upload" size="14" />
      {{ __('buttons.upload') }}
    </b-button>
  </div>
</div>
